const state = {
  vaccineTypes: [],


}

const getters = {}

const actions = {
  getPersons({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/vims/persons")
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getVaccineTypes ({ commit }) {
    axios
      .get("/vims/vtypes")
      .then(response => (commit('setVaccineTypes', response.data.data)));
  },
  getPersonCardInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/vims/person/getPersonCardInfo", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getPersonVacs({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/vims/person/getAllVaccinations", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  updateVimsEntry({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/vims/person/updatePersonRecord", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },

  createVimsEntry({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/vims/person/createPersonRecord", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  getPatientByIdCard ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/vims/person-card-search", params , {
            headers: {
              'Content-Type': 'application/json',
            }
          })
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })

  },


}
const mutations = {

  setVaccineTypes (state, data) {
    state.vaccineTypes = data.data;
  },


}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
